import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=7a290f80&scoped=true"
import script from "./file-item.vue?vue&type=script&lang=ts"
export * from "./file-item.vue?vue&type=script&lang=ts"
import style0 from "./file-item.vue?vue&type=style&index=0&id=7a290f80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a290f80",
  null
  
)

export default component.exports